import {
  HTTPValidationError,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchData,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchResponse,
  updateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatch,
} from '@common/config/api/client'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { queryClient } from '@common/config/api/queryClient.ts'

export const useSaveAdditionalComment = (): UseMutationResult<
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchResponse,
  AxiosError<HTTPValidationError>,
  UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchData
> => {
  return useMutation<
    UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchResponse,
    AxiosError<HTTPValidationError>,
    UpdateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatchData
  >({
    mutationFn: async (query) => {
      const response = await updateAdditionalCommentsStudiesStudyIdAdditionalCommentsPatch({
        body: query.body,
        throwOnError: true,
        path: query.path,
      })
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['TimePointsDetails'] })
    },
  })
}
